export default {
  computed: {
    memberCriterionOptions() {
      return [
        { id: "position", labelKey: "users.mission", fallbackName: "Gorev" },
        { id: "title", labelKey: "users.title", fallbackName: "Unvan" },
        { id: "region", labelKey: "users.area", fallbackName: "Bolge" },
        { id: "department", labelKey: "users.department", fallbackName: "Departman" },
        { id: "branch", labelKey: "users.branch", fallbackName: "Sube" },
      ];
    },
  },
  methods: {
    getMemberCriterionLabel(option) {
      if (!option) return "";
      const hasTranslation = typeof this.$te === "function" && this.$te(option.labelKey);
      if (hasTranslation) return this.$t(option.labelKey);
      return option.fallbackName || option.id;
    },
    getMemberCriterionEndpointByType(type) {
      const endpointByType = {
        title: "api/title",
        position: "api/position",
        department: "api/department",
        branch: "api/branch",
        region: "api/region",
        group: "api/group",
      };

      return endpointByType[type] || null;
    },
    getUserCriterionKeys(type) {
      const idKeys = {
        title: ["title_id"],
        position: ["position_id"],
        department: ["department_id"],
        branch: ["branch_id"],
        region: ["region_id"],
        group: ["group_id", "user_group_id"],
      };
      const relationKeys = {
        title: ["title"],
        position: ["position"],
        department: ["department"],
        branch: ["branch"],
        region: ["region"],
        group: ["group", "groups", "user_group", "user_groups"],
      };

      return {
        idKeys: idKeys[type] || [],
        relationKeys: relationKeys[type] || [],
      };
    },
  },
};

